/**
 * 商城（含子路由）
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/mall',
    component: () => import('@/views/mall/entry.vue'),
    children: [
      {
        path: '',
        name: 'mallIndex',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/mall/index.vue'
          ),
        meta: {
          title: '商城首页',
          is_festivalPop: true
        }
      },
      {
        path: '/mall/list',
        name: 'list',
        component: () =>
          import(
            /* webpackChunkName: "common" */
            '@/views/mall/list.vue'
          ),
        meta: {
          title: '商品列表'
        }
      },
      {
        path: '/mall/addGoods',
        name: 'addGoods',
        component: () =>
          import(
            /* webpackChunkName: "common" */
            '@/views/mall/addGoods.vue'
          ),
        meta: {
          title: '凑单页'
        }
      },
      {
        path: '/mall/detail',
        name: 'detail',
        component: () =>
          import(
            /* webpackChunkName: "common" */
            '@/views/mall/detail.vue'
          ),
        meta: {
          title: '商品详情'
        }
      },
      {
        path: '/mall/active_lists',
        name: 'act_list',
        component: () =>
          import(
            /* webpackChunkName: "common" */
            '@/views/mall/activity_list.vue'
          ),
        meta: {
          title: '活动列表'
        }
      }
    ]
  }
];
